module.exports = __webpack_public_path__ + "img/research.d6357048.jpg";